<template>
  <div id="modernman">
    <div class="container-marcas">
      <div class="banner">
        <div class="titulo">
          <p>MODERNMAN</p>
        </div>
      </div>
      <div class="desc">
        <p class="bold">
         En franco crecimiento del Grupo MLA y con la necesidad de atender a más clientes en la
         Central de Abasto de la Ciudad de México, se crea Modernman, SA de CV.
        </p>
        <p>
        Fue constituida el 14 de noviembre de 2007
        </p>
        <p>
          Es una organización con disciplina, que ha llegado a posicionarse en un lugar muy
          importante en Mexico, en la distribución de frutas finas.
        </p>
      </div>
      <div class="fotos">
        <div class="flex items-center justify-around">
          <div class="foto">
            <img src="@/assets/images/modernman1.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/modernman2.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/modernman3.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/modernman4.jpg" alt="Galeria">
          </div>
        </div>
        <div class="flex items-center justify-around">
          <div class="foto">
            <img src="@/assets/images/modernman/bodega.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/modernman/exterior.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/modernman/oficinas.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/modernman/refrigeradores.jpg" alt="Galeria">
          </div>
        </div>
        <div class="flex items-center justify-around">
          <div class="foto w-30">
            <img src="@/assets/images/modernman/sala-de-juntas.jpg" alt="Galeria">
          </div>
        </div>
      </div>
      <div class="ubicacion">
        <div class="flex-ubi">
          <div class="map">
            <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.9732944505613!2d-99.09009968461383!3d19.37030898691977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1fdc37a327f69%3A0x71517da4abebbf1e!2sGRUPO+MLA!5e0!3m2!1ses-419!2smx!4v1547220444411"
            width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div>
          <div class="direccion">
            <p class="bold">Modernman, S.A. de C.V.</p>
            <p>Zona V, sector 2, nave 4,</p>
            <p>bodega L-118</p>
            <p>Col. Ejido del Moral</p>
            <p>09040, Iztapalapa, Mexico, D.F.</p>
            <p>Conmutador: [52255] 5640 2270</p>
            <p>t. [5255] 5600 8384</p>
            <p>y [5255] 5600 8385</p>
            <p class="underline">tesoreria@grupomla.com.mx</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
#modernman {
  //  p {
  //   font-size: 1.3em;
  // }
  .container-marcas {
    .banner {
      background: url('../../assets/images/kiwi.png');
      background-position: center;
      background-size: cover;
      height: 80vh;
      width: 100%;
      position: relative;

      img {
        z-index: 1;
        width: 100%;
        height: 100%;
      }

      .titulo {
        position: absolute;
        color: #fff;
        font-size: 2.2em;
        font-weight: bold;
        top: 5%;
        left: 4%;
      }

    }
    .desc {
      font-size: 1.3em;
      padding: 0 10%;
      padding-bottom: 50px;
      margin-bottom: 50px;

      .bold {
        font-weight: bold;
      }

    }
    .fotos {
      width: 90%;
      margin: 0 auto;
      margin-bottom: 50px;

      .flex {
        display: flex;
        justify-content: center;

        .foto {
          margin: 10px 10px;;
        }
      }

    }
    .ubicacion {
      width: 80%;
      margin: 0 auto;

      .flex-ubi {
        height: 70vh;
        display: flex;
        justify-content: center;

        .map {
          width: 50%;
        }
        .direccion {
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: 5px;


          .bold {
            font-weight: bold;
          }

          .underline {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
